import TextUtil from "../../../../../shared/lib/html5-software-library/src/ranj/components/text/TextUtil";
import AbstractPopupMediator from "../../../../../shared/src/ranj/app/ui/AbstractPopupMediator";
import TutorialOverlayMediatorEvent from "../model/TutorialOverlayMediatorEvent";
import TutorialPlayerEvent from "../model/TutorialPlayerEvent";

export default class TutorialOverlayMediator extends AbstractPopupMediator {

    constructor(target, dispatcher, languagePack, layoutManager, gameConfig) {
        super(target, dispatcher, languagePack, layoutManager);
        this._gameConfig = gameConfig;

        this._stepPanel9SliceMap = {};
    }


    initialize() {
        super.initialize();
        this._setPage(0);

        this.registerEventListener(TutorialPlayerEvent.NEXT_STEP, this._handleNextTutorialStep.bind(this));
        this.registerEventListener(TutorialPlayerEvent.COMPLETE_STEP, this._handleCompleteTutorialStep.bind(this));
    }

    _handleNextTutorialStep(evt) {
        const stepIndex = evt.params.data.stepIndex;
        this._setPage(stepIndex);

        const step = this._target[`step${stepIndex}`];
        step.alpha = 1;
    }

    _handleCompleteTutorialStep(evt) {
        const stepIndex = evt.params.data.stepIndex;
        const step = this._target[`step${stepIndex}`];
        step.alpha = 0;
    }

    _handleNext() {
        this._changePage(1);
    }
    _handlePrev() {
        this._changePage(-1);
    }

    _changePage(delta) {
        const f = Math.max(0, this._target.currentFrame + delta);
        const n = this._target.totalFrames;
        if (f >= n) {
            this.close();
        } else {
            const duration = this._gameConfig.getValue("tutorial.crossFadeDuration");
            const wait = this._gameConfig.getValue("tutorial.crossFadeDelay");
            createjs.Tween.get(this._target)
                .to({ alpha: 0 }, duration, createjs.Ease.quadOut)
                .call(() => {
                    this._setPage(f);
                })
                .wait(wait)
                .to({ alpha: 1 }, duration, createjs.Ease.quadIn);
        }
    }

    _createOrGetStepPanel9Slice(step) {
        if (!this._stepPanel9SliceMap.hasOwnProperty(step)) {
            this._stepPanel9SliceMap[step] = this.createGenericVerticalSlice9Panel(step);
        }
        return this._stepPanel9SliceMap[step];
    }

    _setPage(idx) {
        this._target.gotoAndStop(idx);

        const prefix = `tutorial.overlay${idx}.`;

        const step = this._target[`step${idx}`];
        
        // This was necessary to prevent the 9 sliced background from rendering on top
        step.gotoAndStop(0);

        const upArrow = step.upArrow;
        const downArrow = step.downArrow;

        var downArrowYOffset = 0;

        if (idx >= 1 && idx <= 5) {
            // Hide any arrows so they don't interfere with nine slicing calculations.
            if (upArrow) {
                upArrow.visible = false;
            }
            if (downArrow) {
                downArrow.visible = false;
            }
            var slice9Panel = this._createOrGetStepPanel9Slice(step);
        }

        const titleTextField = step.titleTextfield;
        if (titleTextField) {
            titleTextField.text = this.getText(prefix + "title");
        }

        const bodyTextField = step.bodyTextfield;
        if (bodyTextField) {
            var oldHeight = bodyTextField.getMeasuredHeight();
            bodyTextField.text = this.getText(prefix + "body");
            downArrowYOffset += bodyTextField.getMeasuredHeight() - oldHeight;
        }

        const actionTextField = step.actionTextfield;
        if (actionTextField) {
            var oldY = bodyTextField.y;
            actionTextField.text = this.getText(prefix + "action");
            actionTextField.y = bodyTextField.y + bodyTextField.getMeasuredHeight() + 40;
            downArrowYOffset += actionTextField.y - oldY;
        }
        
        // Reposition down arrow (if present in this step) after text height changes. Any up arrows can stay in place.
        if (downArrow) {
            downArrow.y += downArrowYOffset;
        }

        const startButtonSkin = step.startButton;
        if (startButtonSkin) {
            if (this._startButton) {
                this._startButton.destroy();
                this._startButton = null;
            }

            const startButtonLabel = this.getText(prefix + "startButton");
            this._startButton = this.createButton(startButtonSkin, () => {
                this._startButton.setEnabled(false);
                this.dispatch(TutorialOverlayMediatorEvent.CONTINUE_BUTTON_CLICKED);
            }, startButtonLabel);
        }

        const replayButtonSkin = step.replayButton;
        if (replayButtonSkin) {
            if (this._replayButton) {
                this._replayButton.destroy();
            }

            const replayButtonLabel = this.getText(prefix + "replayButton");
            this._replayButton = this.createButton(replayButtonSkin, () => {
                this._replayButton.setEnabled(false);
                this.dispatch(TutorialOverlayMediatorEvent.REPLAY_BUTTON_CLICKED);
            });

            this._replayButton.setCenteredLabel(replayButtonLabel);
        }

        const overlaySkin = step.overlay;
        if (overlaySkin) {
            if (this._overlayButton) {
                this._overlayButton.destroy();
                this._overlayButton = null;
            }

            this._overlayButton = this.createButton(overlaySkin, () => {
                // eat click
                console.log(`[TutorialOverlayMediator] Overlay button eats the click!`);
            });

            overlaySkin.cursor = "default";
        }

        if (slice9Panel) {
            slice9Panel.update();
            
            // Show arrows again after nine slicing calculations are done
            if (upArrow) {
                upArrow.visible = true;
            }
            if (downArrow) {
                downArrow.visible = true;
            }
        }
    }
}